<template lang="pug">
  b-row
    .col-xl-12
      panel(:title='$t("title.commission_settings")' :bodyClass="'childBody'")
        b-row
          .col-sm-12.col-md-12.col-lg-12.col-xl-12
            #tblModal.table-sm.table-responsive
              table.table.table-bordered
                tbody
                  //- tr(v-show="this.$helpers.isAgentLevel()")
                  tr
                    th {{ comm_sportsbook_hdp_packages_title }}
                    td
                      b-form-select(
                        ref="hdpPackage"
                        :class="{ 'is-invalid': $v.packageSelected.$dirty == true && $v.packageSelected.$error == true, 'is-valid': $v.packageSelected.$dirty == true && $v.packageSelected.$error == false }"
                        lazy-formatter=false
                        :options="hdpPackageList"
                        v-model="$v.packageSelected.$model"
                        size="sm"
                        :disabled="loading"
                      )
                  //- tr(v-if="show('A')")
                  //-   th {{ comm_sportsbook_hdp_a_title }}
                  //-   td
                  //-     PTSelect(
                  //-       ref="comm_sportsbook_hdp_a"
                  //-       :dirty="$v.comm_sportsbook_hdp_a.$dirty"
                  //-       :error="$v.comm_sportsbook_hdp_a.$error"
                  //-       :options="comm_sportsbook_hdp_a_options"
                  //-       v-model="$v.comm_sportsbook_hdp_a.$model"
                  //-       :disabled="loading"
                  //-     )
                  //- tr(v-if="show('B')")
                  //-   th {{ comm_sportsbook_hdp_b_title }}
                  //-   td
                  //-     PTSelect(
                  //-       ref="comm_sportsbook_hdp_b"
                  //-       :dirty="$v.comm_sportsbook_hdp_b.$dirty"
                  //-       :error="$v.comm_sportsbook_hdp_b.$error"
                  //-       :options="comm_sportsbook_hdp_b_options"
                  //-       v-model="$v.comm_sportsbook_hdp_b.$model"
                  //-       :disabled="loading"
                  //-     )
                  //- tr(v-if="show('C')")
                  //-   th {{ comm_sportsbook_hdp_c_title }}
                  //-   td
                  //-     PTSelect(
                  //-       ref="comm_sportsbook_hdp_c"
                  //-       :dirty="$v.comm_sportsbook_hdp_c.$dirty"
                  //-       :error="$v.comm_sportsbook_hdp_c.$error"
                  //-       :options="comm_sportsbook_hdp_c_options"
                  //-       v-model="$v.comm_sportsbook_hdp_c.$model"
                  //-       :disabled="loading"
                  //-     )
                  //- tr(v-if="show('D')")
                  //-   th {{ comm_sportsbook_hdp_d_title }}
                  //-   td
                  //-     PTSelect(
                  //-       ref="comm_sportsbook_hdp_d"
                  //-       :dirty="$v.comm_sportsbook_hdp_d.$dirty"
                  //-       :error="$v.comm_sportsbook_hdp_d.$error"
                  //-       :options="comm_sportsbook_hdp_d_options"
                  //-       v-model="$v.comm_sportsbook_hdp_d.$model"
                  //-       :disabled="loading"
                  //-     )
                  //- tr(v-if="show('E')")
                  //-   th {{ comm_sportsbook_hdp_e_title }}
                  //-   td
                  //-     PTSelect(
                  //-       ref="comm_sportsbook_hdp_e"
                  //-       :dirty="$v.comm_sportsbook_hdp_e.$dirty"
                  //-       :error="$v.comm_sportsbook_hdp_e.$error"
                  //-       :options="comm_sportsbook_hdp_e_options"
                  //-       v-model="$v.comm_sportsbook_hdp_e.$model"
                  //-       :disabled="loading"
                  //-     )
                  //- tr(v-if="show('F')")
                  //-   th {{ comm_sportsbook_hdp_f_title }}
                  //-   td
                  //-     PTSelect(
                  //-       ref="comm_sportsbook_hdp_f"
                  //-       :dirty="$v.comm_sportsbook_hdp_f.$dirty"
                  //-       :error="$v.comm_sportsbook_hdp_f.$error"
                  //-       :options="comm_sportsbook_hdp_f_options"
                  //-       v-model="$v.comm_sportsbook_hdp_f.$model"
                  //-       :disabled="loading"
                  //-     )
                  //- tr
                  //-   th {{ comm_sportsbook_1x2_title }}
                  //-   td
                  //-     PTSelect(
                  //-       ref="comm_sportsbook_1x2"
                  //-       :dirty="$v.comm_sportsbook_1x2.$dirty"
                  //-       :error="$v.comm_sportsbook_1x2.$error"
                  //-       :options="comm_sportsbook_1x2_options"
                  //-       v-model="$v.comm_sportsbook_1x2.$model"
                  //-       :disabled="loading"
                  //-     )
                  //- tr
                  //-   th {{ comm_sportsbook_others_title }}
                  //-   td
                  //-     PTSelect(
                  //-       ref="comm_sportsbook_others"
                  //-       :dirty="$v.comm_sportsbook_others.$dirty"
                  //-       :error="$v.comm_sportsbook_others.$error"
                  //-       :options="comm_sportsbook_others_options"
                  //-       v-model="$v.comm_sportsbook_others.$model"
                  //-       :disabled="loading"
                  //-     )
                  //- template(v-if="$store.getters.getAccountCurrency == 'MMK'")
                  template(v-if="['MMK', 'MMO'].includes($store.getters.getAccountCurrency)")
                    tr
                      th {{ comm_hdp_mmo_title }}
                      td
                        PTSelect(
                          ref="comm_hdp_mmo"
                          :dirty="$v.comm_hdp_mmo.$dirty"
                          :error="$v.comm_hdp_mmo.$error"
                          :options="comm_hdp_mmo_options"
                          v-model="$v.comm_hdp_mmo.$model"
                          :disabled="loading"
                        )
                    tr
                      th {{ comm_parlay_mmo_a_title }}
                      td
                        PTSelect(
                          ref="comm_parlay_mmo_a"
                          :dirty="$v.comm_parlay_mmo_a.$dirty"
                          :error="$v.comm_parlay_mmo_a.$error"
                          :options="comm_parlay_mmo_a_options"
                          v-model="$v.comm_parlay_mmo_a.$model"
                          :disabled="loading"
                        )
                    tr
                      th {{ comm_parlay_mmo_b_title }}
                      td
                        PTSelect(
                          ref="comm_parlay_mmo_b"
                          :dirty="$v.comm_parlay_mmo_b.$dirty"
                          :error="$v.comm_parlay_mmo_b.$error"
                          :options="comm_parlay_mmo_b_options"
                          v-model="$v.comm_parlay_mmo_b.$model"
                          :disabled="loading"
                        )
                  //- tr(v-show="$helpers.isPlatformEnabled('LC')")
                  //-   th {{ comm_casino_title }}
                  //-     span.small.text-danger [{{ $t("ui.manila_nocomm") }}]
                  //-   td
                  //-     PTSelect(
                  //-       ref="comm_casino"
                  //-       :dirty="$v.comm_casino.$dirty"
                  //-       :error="$v.comm_casino.$error"
                  //-       :options="comm_casino_options"
                  //-       v-model="$v.comm_casino.$model"
                  //-       :disabled="loading"
                  //-     )
                  //- tr(v-show="$helpers.isPlatformEnabled('SL')")
                  //-   th {{ comm_slots_title }}
                  //-   td
                  //-     PTSelect(
                  //-       ref="comm_slots"
                  //-       :dirty="$v.comm_slots.$dirty"
                  //-       :error="$v.comm_slots.$error"
                  //-       :options="comm_slots_options"
                  //-       v-model="$v.comm_slots.$model"
                  //-       :disabled="loading"
                  //-     )
                  //- tr(v-show="$helpers.isPlatformEnabled('LO')")
                  //-   th {{ comm_lotto_title }}
                  //-   td
                  //-     PTSelect(
                  //-       ref="comm_lotto"
                  //-       :dirty="$v.comm_lotto.$dirty"
                  //-       :error="$v.comm_lotto.$error"
                  //-       :options="comm_lotto_options"
                  //-       v-model="$v.comm_lotto.$model"
                  //-       :disabled="loading"
                  //-     )
                  //- tr(v-show="$helpers.isPlatformEnabled('KN')")
                  //-   th {{ comm_keno_title }}
                  //-   td
                  //-     PTSelect(
                  //-       ref="comm_keno"
                  //-       :dirty="$v.comm_keno.$dirty"
                  //-       :error="$v.comm_keno.$error"
                  //-       :options="comm_keno_options"
                  //-       v-model="$v.comm_keno.$model"
                  //-       :disabled="loading"
                  //-     )
                  //- tr(v-show="$helpers.isPlatformEnabled('CF')")
                  //-   th {{ comm_cockfight_title }}
                  //-   td
                  //-     PTSelect(
                  //-       ref="comm_cockfight"
                  //-       :dirty="$v.comm_cockfight.$dirty"
                  //-       :error="$v.comm_cockfight.$error"
                  //-       :options="comm_cockfight_options"
                  //-       v-model="$v.comm_cockfight.$model"
                  //-       :disabled="loading"
                  //-     )
                  //- tr(v-show="$helpers.isPlatformEnabled('LT')")
                  //-   th {{ comm_lottery_1d_title }}
                  //-   td
                  //-     PTSelect(
                  //-       ref="comm_lottery_1d"
                  //-       :dirty="$v.comm_lottery_1d.$dirty"
                  //-       :error="$v.comm_lottery_1d.$error"
                  //-       :options="comm_lottery_1d_options"
                  //-       v-model="$v.comm_lottery_1d.$model"
                  //-       :disabled="loading"
                  //-     )
                  //- tr(v-show="$helpers.isPlatformEnabled('LT')")
                  //-   th {{ comm_lottery_2d_title }}
                  //-   td
                  //-     PTSelect(
                  //-       ref="comm_lottery_2d"
                  //-       :dirty="$v.comm_lottery_2d.$dirty"
                  //-       :error="$v.comm_lottery_2d.$error"
                  //-       :options="comm_lottery_2d_options"
                  //-       v-model="$v.comm_lottery_2d.$model"
                  //-       :disabled="loading"
                  //-     )
                  //- tr(v-show="$helpers.isPlatformEnabled('LT')")
                  //-   th {{ comm_lottery_3d_title }}
                  //-   td
                  //-     PTSelect(
                  //-       ref="comm_lottery_3d"
                  //-       :dirty="$v.comm_lottery_3d.$dirty"
                  //-       :error="$v.comm_lottery_3d.$error"
                  //-       :options="comm_lottery_3d_options"
                  //-       v-model="$v.comm_lottery_3d.$model"
                  //-       :disabled="loading"
                  //-     )
                  //- tr(v-show="$helpers.isPlatformEnabled('LT')")
                  //-   th {{ comm_lottery_4d_title }}
                  //-   td
                  //-     PTSelect(
                  //-       ref="comm_lottery_4d"
                  //-       :dirty="$v.comm_lottery_4d.$dirty"
                  //-       :error="$v.comm_lottery_4d.$error"
                  //-       :options="comm_lottery_4d_options"
                  //-       v-model="$v.comm_lottery_4d.$model"
                  //-       :disabled="loading"
                  //-     )
</template>

<script>
import { required, minValue } from "vuelidate/lib/validators";
// import PTSelect from "@/library/PTSelect";

export default {
  components: {
    // PTSelect
  },
  props: {
    loading: false
  },
  data() {
    return {
      hdpPackageDetails: [],
      hdpPackageList: [],
      packageSelected: "",
      // comm_sportsbook_hdp_a: 0,
      // comm_sportsbook_hdp_b: 0,
      // comm_sportsbook_hdp_c: 0,
      // comm_sportsbook_hdp_d: 0,
      // comm_sportsbook_hdp_e: 0,
      // comm_sportsbook_hdp_f: 0,
      // comm_sportsbook_hdp_g: 0,
      // comm_sportsbook_hdp_h: 0,
      // comm_sportsbook_hdp_i: 0,
      // comm_sportsbook_hdp_j: 0,
      // comm_sportsbook_1x2: 0,
      // comm_sportsbook_others: 0,
      // comm_sportsbook_hdp_packages: "A", //"A" or "A","B","C"
      // comm_slots: 0,
      // comm_casino: 0,
      // comm_lotto: 0,
      // comm_keno: 0,
      // comm_cockfight: 0,
      // comm_lottery_1d: 0,
      // comm_lottery_2d: 0,
      // comm_lottery_3d: 0,
      // comm_lottery_4d: 0
    }
  },
  validations: {
    packageSelected:{
      required
    }
    // comm_sportsbook_hdp_a: {
    //   required
    // },
    // comm_sportsbook_hdp_b: {
    //   required
    // },
    // comm_sportsbook_hdp_c: {
    //   required
    // },
    // comm_sportsbook_hdp_d: {
    //   required
    // },
    // comm_sportsbook_hdp_e: {
    //   required
    // },
    // comm_sportsbook_hdp_f: {
    //   required
    // },
    // comm_sportsbook_1x2: {
    //   required
    // },
    // comm_sportsbook_others: {
    //   required
    // },
    // comm_sportsbook_hdp_packages: {
    //   required
    // },
    // comm_slots: {
    //   required
    // },
    // comm_casino: {
    //   required
    // },
    // comm_lotto: {
    //   required
    // },
    // comm_keno: {
    //   required
    // },
    // comm_cockfight: {
    //   required
    // },
    // comm_lottery_1d: {
    //   required
    // },
    // comm_lottery_2d: {
    //   required
    // },
    // comm_lottery_3d: {
    //   required
    // },
    // comm_lottery_4d: {
    //   required
    // }
  },
  computed: {
    comm_sportsbook_hdp_packages_title: function() {
      return this.$t("ui.hdp_packages")
    },
    // comm_sportsbook_hdp_packages_options: function() {
    //   let packages = this.$store.getters.getCommSBPackages
    //   let result = []
    //   if(packages) {
    //     packages.split(",").forEach((value, index) => {
    //       result.push({value:value, text:this.$t("ui.combine.comm_limit_" + value)})
    //     })
    //   }
    //   return result
    // },
    // comm_sportsbook_hdp_a_title: function() {
    //   return this.$t("ui.combine.comm_limit_A") + " (" + this.comm_sportsbook_hdp_a_max + ")"
    // },
    // comm_sportsbook_hdp_a_max: function() {
    //   return this.$store.getters.getCommSB('hdp_a')
    // },
    // comm_sportsbook_hdp_a_options: function() {
    //   return this.$helpers.getCommRateList(this.comm_sportsbook_hdp_a_max)
    // },
    // comm_sportsbook_hdp_b_title: function() {
    //   return this.$t("ui.combine.comm_limit_B") + " (" + this.comm_sportsbook_hdp_b_max + ")"
    // },
    // comm_sportsbook_hdp_b_max: function() {
    //   return this.$store.getters.getCommSB('hdp_b')
    // },
    // comm_sportsbook_hdp_b_options: function() {
    //   return this.$helpers.getCommRateList(this.comm_sportsbook_hdp_b_max)
    // },
    // comm_sportsbook_hdp_c_title: function() {
    //   return this.$t("ui.combine.comm_limit_C") + " (" + this.comm_sportsbook_hdp_c_max + ")"
    // },
    // comm_sportsbook_hdp_c_max: function() {
    //   return this.$store.getters.getCommSB('hdp_c')
    // },
    // comm_sportsbook_hdp_c_options: function() {
    //   return this.$helpers.getCommRateList(this.comm_sportsbook_hdp_c_max)
    // },
    // comm_sportsbook_hdp_d_title: function() {
    //   return this.$t("ui.combine.comm_limit_D") + " (" + this.comm_sportsbook_hdp_d_max + ")"
    // },
    // comm_sportsbook_hdp_d_max: function() {
    //   return this.$store.getters.getCommSB('hdp_d')
    // },
    // comm_sportsbook_hdp_d_options: function() {
    //   return this.$helpers.getCommRateList(this.comm_sportsbook_hdp_d_max)
    // },
    // comm_sportsbook_hdp_e_title: function() {
    //   return this.$t("ui.combine.comm_limit_E") + " (" + this.comm_sportsbook_hdp_e_max + ")"
    // },
    // comm_sportsbook_hdp_e_max: function() {
    //   return this.$store.getters.getCommSB('hdp_e')
    // },
    // comm_sportsbook_hdp_e_options: function() {
    //   return this.$helpers.getCommRateList(this.comm_sportsbook_hdp_e_max)
    // },
    // comm_sportsbook_hdp_f_title: function() {
    //   return this.$t("ui.combine.comm_limit_F") + " (" + this.comm_sportsbook_hdp_f_max + ")"
    // },
    // comm_sportsbook_hdp_f_max: function() {
    //   return this.$store.getters.getCommSB('hdp_f')
    // },
    // comm_sportsbook_hdp_f_options: function() {
    //   return this.$helpers.getCommRateList(this.comm_sportsbook_hdp_f_max)
    // },
    // comm_sportsbook_1x2_title: function() {
    //   return this.$t("ui.oxt") + "/" + this.$t("ui.double_chance") + " (" + this.comm_sportsbook_1x2_max + ")"
    // },
    // comm_sportsbook_1x2_max: function() {
    //   return this.$store.getters.getCommSB('one_x_two')
    // },
    // comm_sportsbook_1x2_options: function() {
    //   return this.$helpers.getCommRateList(this.comm_sportsbook_1x2_max)
    // },
    // comm_sportsbook_others_title: function() {
    //   return this.$t("ui.others") + " (" + this.comm_sportsbook_others_max + ")"
    // },
    // comm_sportsbook_others_max: function() {
    //   return this.$store.getters.getCommSB('others')
    // },
    // comm_sportsbook_others_options: function() {
    //   return this.$helpers.getCommRateList(this.comm_sportsbook_others_max)
    // },
    // comm_casino_title: function() {
    //   return this.$t("ui.live_casino") + " (" + this.comm_casino_max + ")"
    // },
    // comm_casino_max: function() {
    //   return this.$store.getters.getCommLC
    // },
    // comm_casino_options: function() {
    //   return this.$helpers.getCommRateList(this.comm_casino_max)
    // },
    // comm_slots_title: function() {
    //   return this.$t("ui.slot_games") + " (" + this.comm_slots_max + ")"
    // },
    // comm_slots_max: function() {
    //   return this.$store.getters.getCommSL
    // },
    // comm_slots_options: function() {
    //   return this.$helpers.getCommRateList(this.comm_slots_max)
    // },
    // comm_lotto_title: function() {
    //   return this.$t("ui.lotto") + " (" + this.comm_lotto_max + ")"
    // },
    // comm_lotto_max: function() {
    //   return this.$store.getters.getCommLO
    // },
    // comm_lotto_options: function() {
    //   return this.$helpers.getCommRateList(this.comm_lotto_max)
    // },
    // comm_keno_title: function() {
    //   return this.$t("ui.keno") + " (" + this.comm_keno_max + ")"
    // },
    // comm_keno_max: function() {
    //   return this.$store.getters.getCommKN
    // },
    // comm_keno_options: function() {
    //   return this.$helpers.getCommRateList(this.comm_keno_max)
    // },
    // comm_cockfight_title: function() {
    //   return this.$t("ui.cockfight") + " (" + this.comm_cockfight_max + ")"
    // },
    // comm_cockfight_max: function() {
    //   return this.$store.getters.getCommCF
    // },
    // comm_cockfight_options: function() {
    //   return this.$helpers.getCommRateList(this.comm_cockfight_max)
    // },
    // comm_lottery_1d_title: function() {
    //   return this.$t("ui.lottery_1d") + " (" + this.comm_lottery_1d_max + ")"
    // },
    // comm_lottery_1d_max: function() {
    //   if(this.$store.getters.getCommLT){
    //     return this.$store.getters.getCommLT[0].one_d
    //   }
    // },
    // comm_lottery_1d_options: function() {
    //   return this.$helpers.getCommRateList(this.comm_lottery_1d_max)
    // },
    // comm_lottery_2d_title: function() {
    //   return this.$t("ui.lottery_2d") + " (" + this.comm_lottery_2d_max + ")"
    // },
    // comm_lottery_2d_max: function() {
    //   if(this.$store.getters.getCommLT){
    //     return this.$store.getters.getCommLT[0].two_d
    //   }
    // },
    // comm_lottery_2d_options: function() {
    //   return this.$helpers.getCommRateList(this.comm_lottery_2d_max)
    // },
    // comm_lottery_3d_title: function() {
    //   return this.$t("ui.lottery_3d") + " (" + this.comm_lottery_3d_max + ")"
    // },
    // comm_lottery_3d_max: function() {
    //   if(this.$store.getters.getCommLT){
    //     return this.$store.getters.getCommLT[0].three_d
    //   }
    // },
    // comm_lottery_3d_options: function() {
    //   return this.$helpers.getCommRateList(this.comm_lottery_3d_max)
    // },
    // comm_lottery_4d_title: function() {
    //   return this.$t("ui.lottery_4d") + " (" + this.comm_lottery_4d_max + ")"
    // },
    // comm_lottery_4d_max: function() {
    //   if(this.$store.getters.getCommLT){
    //     return this.$store.getters.getCommLT[0].four_d
    //   }
    // },
    // comm_lottery_4d_options: function() {
    //   return this.$helpers.getCommRateList(this.comm_lottery_4d_max)
    // }
  },
  mounted: function() {
    // this.$helpers.getPlatform()
    this.getCommission()
  },
  methods: {
    show: function(mode) {
      let result = false
      if(this.$helpers.isAgentLevel()) {
        if (this.comm_sportsbook_hdp_packages == mode){
          result = true
        }
      } else {
        result = true
      }
      return result
    },
    getCommission() {
      let account_id = this.$store.getters.accountID
      this.$store
        .dispatch("user/getCommission", { account_id })
        .then(response => {
          if(response.success == true) {
            var packageData = response.data[0]
            this.hdpPackageDetails = response.data;
            this.hdpPackageList = response.data[0].hdp_packages.split(",")
            if(this.hdpPackageList.length > 0){
              this.packageSelected = this.hdpPackageList[0];
            }

            // if(this.$store.getters.getAccountCurrency == 'MMK') {
            if(['MMK', 'MMO'].includes(this.$store.getters.getAccountCurrency)) {
              this.$v.comm_hdp_mmo.$model = this.comm_hdp_mmo_max
              this.$v.comm_parlay_mmo_a.$model = this.comm_parlay_mmo_a_max
              this.$v.comm_parlay_mmo_b.$model = this.comm_parlay_mmo_b_max
            }
          }
          // if(this.comm_sportsbook_hdp_packages_options){
            // if(!this.$helpers.isAgentLevel()) {
            //   this.$v.comm_sportsbook_hdp_packages.$model = this.$store.getters.getCommSBPackages
            // } else {
              // this.$v.comm_sportsbook_hdp_packages.$model = this.comm_sportsbook_hdp_packages_options[0].value
            // }
          // }
          // this.$v.comm_sportsbook_hdp_a.$model = this.comm_sportsbook_hdp_a_max
          // this.$v.comm_sportsbook_hdp_b.$model = this.comm_sportsbook_hdp_b_max
          // this.$v.comm_sportsbook_hdp_c.$model = this.comm_sportsbook_hdp_c_max
          // this.$v.comm_sportsbook_hdp_d.$model = this.comm_sportsbook_hdp_d_max
          // this.$v.comm_sportsbook_hdp_e.$model = this.comm_sportsbook_hdp_e_max
          // this.$v.comm_sportsbook_hdp_f.$model = this.comm_sportsbook_hdp_f_max
          // this.$v.comm_sportsbook_1x2.$model = this.comm_sportsbook_1x2_max
          // this.$v.comm_sportsbook_others.$model = this.comm_sportsbook_others_max
          // this.$v.comm_casino.$model = this.comm_casino_max
          // // this.$v.comm_slots.$model = this.comm_slots_max
          // this.$v.comm_lotto.$model = this.comm_lotto_max
          // this.$v.comm_keno.$model = this.comm_keno_max
          // this.$v.comm_cockfight.$model = this.comm_cockfight_max
          // this.$v.comm_lottery_1d.$model = this.comm_lottery_1d_max
          // this.$v.comm_lottery_2d.$model = this.comm_lottery_2d_max
          // this.$v.comm_lottery_3d.$model = this.comm_lottery_3d_max
          // this.$v.comm_lottery_4d.$model = this.comm_lottery_4d_max
        })
        .catch(response => {
        });
    }
  }
}
</script>